import Vue from "vue";
import Vuetify from "vuetify/lib";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#3826D8", // "#0080AA",
        "legacy-primary": "#0080AA",
        "legacy-secondary": "#00A8E1",
        secondary: "#00A8E1",
        "plus-text": "#53657B",
        accent: "#8C9EFF",
        error: "#EA0C0C",
        "election-status-running": "6799FF",
        "election-status-lost": "#F25E51",
        "election-status-won": "#0DD1A0",
        "election-status-withdrawn": colors.grey.base,
        "election-status-too-close-to-call": "#FDB13D",
        // anchor, info, success, warning left unchanged
      },
    },
    options: {
      customProperties: true,
    },
  },
  icons: {
    iconfont: "md",
  },
});
